import { useState } from "react";
import { FDWResultEntry } from "../../../restfd2/fdw_result";
import { FundingsListItem } from "./fundings_list_item";

export function FundingsListAccordion(props: {
	  active: boolean,
	  regions: Record<string, { region: string, list: Array<FDWResultEntry> }>
	}) {
		const [activeElements, setActiveElements] = useState<Set<string>>(() => {
		  const firstKey = Object.keys(props.regions)[0];
		  return new Set([firstKey]); // Set mit dem ersten Key
		});

	  const toggleElement = (key: string) => {
		setActiveElements(prev => {
		  const newSet = new Set(prev);
		  newSet.has(key) ? newSet.delete(key) : newSet.add(key);
		  return newSet;
		});
	  };

	  return (
		<div className="accordion">
		  {props.active && Object.keys(props.regions).map((key: string) => {
			const region = props.regions[key];
			const isActive = activeElements.has(key);

			return (
			  <div className="accordion__element" key={key}>
				<h3 className="accordion__element_title" 
        tabIndex={0} 
        onClick={() => toggleElement(key)}
        onKeyUp={(event) => {
          if(event.code != "Enter" && event.code != " "){return;}
          toggleElement(key)
        }}
        >
				  <div className={`icon accordion__element_icon ${isActive ? "accordion__element_icon--active" : ""}`} />
				  <span>{region.region} ({region.list.length})</span>
				</h3>
				{isActive && region.list.map((entry: FDWResultEntry) =>
				  <FundingsListItem key={entry.fp_id} entry={entry} />
				)}
			  </div>
			);
		  })}
		</div>
	  );
}